module.exports = "/assets/gift-events-listing/WR_banner_mobile-cz.png?qBHXl1/";